<template>
  <v-col cols="12" md="8" class="mx-auto my-12 primary-form">
    <h2 class="h4 mt-5 center-text">RSVP: <span class="form-title">{{ fields.formTitle }}</span></h2>

    <div class="submit-success-container" v-if="submitted">
      <div class="submit-summary">
        <div class="confirmationMessage">
          {{ selectedEvent.confirmationMessage }}
        </div>
        <div>{{ model.userInfo.first }} {{ model.userInfo.last }}</div>
        <div>{{ model.userInfo.email }} - {{ model.userInfo.phone }}</div>

        <h4 class="submit-event-name">{{ selectedEvent.eventName }}</h4>
        <div>{{ selectedEvent.eventPhysicalLocation }}</div>
        <div>{{ selectedEvent.eventVirtualLocation }}</div>
        <div>{{ timeSlotChoice }}</div>
      </div>
    </div>

    <!-- Location select -->
    <div class="location-container" v-if="!selectedEvent && !submitted">
      <h3 class="white-text center-text select-location-header">Which event willl you be attending?</h3>
      <base-button
      class="location-button"
      :inverted="true"
      v-for="event in formEvents"
      :key="event.id"
      :text="event.eventName"
      @click="selectEvent(event)"
      >{{ event.eventName }}</base-button>
    </div>

    <!-- Form fillout -->
    <div v-if="selectedEvent && !submitted">
      <div class="location-container">
        <button class="diff-loc-button" @click="clearEventChoice()">Change location</button>
        <h2 class="event-header center-text white-text">
          <v-icon color="white" class="event-icon" postfix v-if="!isVirtualEvent()"> location_on </v-icon>
          <v-icon color="white" class="event-icon" postfix v-if="isVirtualEvent()"> computer </v-icon>
          {{ selectedEvent.eventName }}
        </h2>
        <div class="info-container">
          <h4 class="white-text event-location"> {{ selectedEvent.eventPhysicalLocation }} </h4>
          <h4 class="white-text event-location"> {{ selectedEvent.eventVirtualLocation }} </h4>
        </div>
        <div class="time-container">
          <div v-for="time in selectedEvent.eventTimeSlots" :key="time">
            <h4 class="event-time-item">{{ formatDateString(time) }}</h4>
          </div>
        </div>
      </div>
      <v-form v-if="!submitted" key="rsvp-form" ref="form">
        <!-- NAME -->
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-label for="first"> First name: </v-label>
            <base-input
                v-model="model.userInfo.first"
                name="first"
                color="primary"
                required
                :max-length="50"
                :restrict-length="true"
                name-field
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-label for="last"> Last name: </v-label>
            <base-input
                v-model="model.userInfo.last"
                name="last"
                color="primary"
                required
                :max-length="50"
                :restrict-length="true"
                name-field
            />
          </v-col>
        </v-row>

        <!-- CONTACT -->
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-label for="email"> Email: </v-label>
            <base-input
                v-model="model.userInfo.email"
                name="email"
                color="primary"
                required
                email
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-label for="phone"> Phone: </v-label>
            <base-input
                v-model="model.userInfo.phone"
                name="phone"
                color="primary"
                required
                phone
            />
          </v-col>
        </v-row>

        <custom-select-new
          ref="timeSlotSelect"
          name="timeSlotSelect"
          v-model="model.timeSlotChoice"
          display="Time slot:"
          :items="timeSlots"
          @optionSelected="(selected) => setTimeSlotChoice(selected)"
          required />

        <div class="center-text err-container" v-if="didError">
          <div>There was an error processing your request.</div>
        </div>

        <div class="d-flex justify-center submit-container">
          <base-button
            text="Submit"
            type="submit"
            @click="submit"
            :loading="loading"
            :disabled="loading || !validate()"/>
        </div>
      </v-form>
    </div>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import $http from '@/plugins/axios'
// import VueRecaptcha from 'vue-recaptcha'
import CustomSelectNew from '../../base/custom-select-new.vue'
import { queryEntryCTF } from '@/plugins/contentful'

export default {
  name: 'RsvpForm',
  components: {
    // VueRecaptcha,
    CustomSelectNew
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedEvent: undefined,
      timeSlots: [],
      timeSlotChoice: '',
      submitted: false,
      loading: false,
      didError: false,
      recaptchaNotValidated: false, // TEMPORARY: Put this back when recaptcha work is up and running again
      recaptchaValidationToken: null,
      siteKey: process.env.VUE_APP_RECAPTCHA_PUBLIC,
      formEvents: [],
      model: {
        recaptchaToken: '',
        userInfo: {
          first: '',
          last: '',
          email: '',
          phone: '',
          attendance: 0
        }
      }
    }
  },
  computed: {
    ...mapState({ siteConfig: (state) => state.site.siteConfig })
  },
  async created () {
    const eventList = this.fields.eventList
    for (const event of eventList) {
      // Load the child event data from contentful
      const item = await queryEntryCTF(event.sys.id)
      this.formEvents.push(item.fields)
    }
  },
  methods: {
    submit () {
      const payload = this.buildFormSumbission()
      console.log(payload)
      this.loading = true
      $http()
        .post('EventFunction', payload, { handleError: false })
        .then(() => {
          this.submitted = true
        })
        .catch(() => {
          this.didError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    validate () {
      const form = this.$refs.form
      if (!form) return false
      if (this.recaptchaNotValidated) return false
      const errs = form.inputs.filter(function (input) {
        return !input.validate(true)
      })
      if (errs.length) {
        return false
      } else {
        return true
      }
    },
    verifyResponse (success) {
      this.recaptchaValidationToken = success
      this.model.recaptchaToken = this.recaptchaValidationToken
      this.recaptchaNotValidated = false
    },
    captchaExpired () {
      this.recaptchaValidationToken = ''
      this.model.recaptchaToken = ''
      this.recaptchaNotValidated = true
    },
    formatDateString (dateStr) {
      if (!dateStr) return ''
      // Parse the input string
      const [datePart, startTime, dash, endTime, period] = dateStr.match(/(\d{2}\/\d{2}\/\d{4}) (\d{1,2}:\d{2}) (\w{2}) - (\d{1,2}:\d{2}) (\w{2})/).slice(1)

      // Create a date object from the date part and start time
      const [month, day, year] = datePart.split('/')
      const date = new Date(`${month}/${day}/${year}`)

      // Get day of week and month name
      const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' })
      const monthName = date.toLocaleDateString('en-US', { month: 'long' })

      // Format the output
      return `${dayOfWeek} - ${monthName} ${parseInt(day)}, ${year} ${startTime} ${dash} - ${endTime} ${period}`
    },
    selectEvent (event) {
      this.selectedEvent = event
      this.setTimeSlots()
    },
    setTimeSlots () {
      this.timeSlots = []
      this.selectedEvent.eventTimeSlots.forEach(time => {
        this.timeSlots.push(this.formatDateString(time))
      })
      this.setTimeSlotChoice(this.timeSlots[0]) // defualt to first time slot
    },
    setTimeSlotChoice (selected) {
      this.timeSlotChoice = selected
    },
    clearEventChoice () {
      this.selectedEvent = undefined
    },
    isVirtualEvent () {
      return this.selectedEvent.eventVirtualLocation !== undefined
    },
    buildFormSumbission () {
      return {
        eventId: this.selectedEvent.eventId,
        first: this.model.userInfo.first,
        last: this.model.userInfo.last,
        email: this.model.userInfo.email,
        phone: this.model.userInfo.phone,
        eventSlot: this.timeSlotChoice,
        recaptchaToken: this.model.recaptchaToken
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../styles/variables';
  h2{
    font-size: 40px !important;
  }

  h4{
    margin-bottom: 10px;
  }

  .event-location{
    margin: 0px;
    font-size: 18px;
    font-style: italic;
    text-decoration: underline;
  }

  .center-text{
    text-align: center;
  }

  .form-title{
    text-decoration: underline;
  }

  .event-header{
    display: flex;
    justify-content: center;
  }

  .info-container{
    display: flex;
    padding: 5px;
    justify-content: center;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .select-location-header{
    margin-bottom: 20px;
  }

  .event-icon{
    padding-right: 10px;
    font-size: 35px;
  }

  .location-container{
    background: #007bbd;
    color: white;
    border-radius: 5px;
    margin: 30px 0px;
    padding: 10px;
    position: relative;
    padding-bottom: 35px;
  }

  .recaptcha{
    margin-top: 20px;
  }

  .time-container{
    display: block;
    margin: auto;
    text-align: center;
    background-color: white;
    color: black;
    border-radius: 5px;
    width: 60%;
    font-weight: 100;
    margin-bottom: 15px;
  }

  .event-time-item{
    font-size: 16px;
    margin: 0;
    padding: 0;
  }

  .time-title{
    margin-bottom: 10px;
    font-weight: 600;
  }

  .white-text{
    color: white !important;
  }

  .location-button{
    width: 300px;
    height: 60px;
    border-radius: 5px;
    margin: auto;
    margin-bottom: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    font-size: 25px;
    font-weight: 600;
  }

  .diff-loc-button{
    position: absolute;
    right: 10px;
    bottom: 5px;
    text-decoration: underline;
  }

  .submit-container{
    margin-top: 20px;
  }

  .submit-success-container{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 40px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    font-weight: 600;
    padding: 10px 10px;

    .submit-summary{
      width: 100%;
    }

    .confirmationMessage{
      color: white;
      font-size: 22px;
      width: 100%;
      margin-bottom: 15px;
      background: #007bbd;
      border-radius: 5px;
      padding: 20px;
      width: 100%;
    }

    .submit-event-name{
      margin-top: 20px;
      border-top: solid gray 1px;
      padding-top: 20px;
    }
  }

  .err-container{
    margin-top: 20px;
    color: red;
  }
</style>
